import React, { Component, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Row,
  Col,
  Card,
  CardHeader,
  CardTitle,
  CardBody,
  Table,
  Spinner,
  Button,
} from 'reactstrap';
import { Link, useHistory } from 'react-router-dom';

import { getProduk } from '../../actions/ProdukAction';
import { DELETE_PRODUK, GET_TOKEN } from 'utils';

import swal from 'sweetalert';
import axios from 'axios';
import jwt_decode from 'jwt-decode';
import { logOutUser } from 'actions/AuthAction';

export default function ListProduk() {
  const dispatch = useDispatch();
  const history = useHistory();

  const { getListProdukError, getListProdukLoading, getListProdukResult } =
    useSelector((state) => state.ProdukReducer);

  // auth

  const [token, setToken] = useState('');
  const [nama, setNama] = useState('');
  const [username, setUsername] = useState('');
  const [akses, setAkses] = useState('');
  const [expire, setExpire] = useState('');
  const [idAdmin, setIdAdmin] = useState('1');
  const [accessToken, setAccessToken] = useState('');

  const refreshToken = async () => {
    try {
      const response = await axios.get(GET_TOKEN + '/token');
      setToken(response.data);
      const decoded = jwt_decode(response.data.accessToken);
      setNama(decoded.nama);
      setUsername(decoded.username);
      setAccessToken(response.data.accessToken);
      setAkses(decoded.akses.split(','));
      setExpire(decoded.exp);
      setIdAdmin(decoded.idAdmin);
    } catch (error) {
      if (error.response) {
        dispatch(logOutUser(history));
        history.push('/');
      }
    }
  };

  const axiosJWT = axios.create();

  axiosJWT.interceptors.request.use(
    async (config) => {
      const currentDate = new Date();
      if (expire * 1000 < currentDate.getTime()) {
        const response = await axios.get(GET_TOKEN + '/token');
        config.headers.Authorization = `Bearer ${response.data.accessToken}`;
        setToken(response.data.accessToken);
        const decoded = jwt_decode(response.data.accessToken);
        setNama(decoded.nama);
        setUsername(decoded.username);
        setAkses(decoded.akses);
        setIdAdmin(decoded.idAdmin);
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  //auth

  useEffect(() => {
    dispatch(getProduk());
    refreshToken();
  }, []);

  const removeData = async (id) => {
    try {
      await axios.delete(DELETE_PRODUK + `${id}`, {
        credentials: 'include',
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      swal('Sukses!', 'Produk berhasil dihapus', 'success');
      history.push('/admin');
      history.push('/admin/produk');
    } catch (error) {
      swal('Failed!', 'Forbiden', 'error');
    }
  };

  return (
    <div className='content'>
      <Row>
        <Col md='12'>
          <Card>
            <CardHeader>
              <CardTitle tag='h4'>List Produk</CardTitle>
              <Link
                to={'/admin/produk/tambah/' + idAdmin}
                className='btn btn-primary float-right'
              >
                Tambah Produk
              </Link>
            </CardHeader>
            <CardBody style={{ overflowX: 'auto' }}>
              <Table>
                <thead className='text-primary'>
                  <tr>
                    <th>Id</th>
                    <th>Foto</th>
                    <th>Nama</th>
                    <th>Jenis</th>
                    <th>Berat</th>
                    <th>Harga</th>
                    <th>Toko</th>
                    <th>Ukuran</th>
                    <th>Aksi</th>
                  </tr>
                </thead>

                <tbody>
                  {getListProdukResult ? (
                    Object.keys(getListProdukResult).map((key) => (
                      <tr key={key}>
                        <td>{getListProdukResult[key].id}</td>
                        <td>
                          <img
                            src={getListProdukResult[key].gambar.split(',')[0]}
                            width='100'
                            alt={getListProdukResult[key].nama}
                          />
                        </td>
                        <td>{getListProdukResult[key].nama}</td>
                        <td>{getListProdukResult[key].jenis}</td>
                        <td>{getListProdukResult[key].berat} kg </td>
                        <td>{getListProdukResult[key].harga} </td>
                        <td>{getListProdukResult[key].toko} </td>
                        <td>{getListProdukResult[key].ukuran} </td>
                        <td>
                          <Link
                            className='btn btn-warning'
                            to={
                              '/admin/produk/edit/' +
                              getListProdukResult[key].id +
                              ',' +
                              idAdmin
                            }
                          >
                            <i className='nc-icon nc-ruler-pencil'></i> Edit
                          </Link>
                        </td>
                        <td>
                          <Button
                            color='danger'
                            className='ml-2'
                            onClick={() =>
                              removeData(getListProdukResult[key].id)
                            }
                          >
                            <i className='nc-icon nc-basket'></i> Hapus
                          </Button>
                        </td>
                      </tr>
                    ))
                  ) : getListProdukLoading ? (
                    <tr>
                      <td colSpan='6' align='center'>
                        <Spinner color='primary' />
                      </td>
                    </tr>
                  ) : getListProdukError ? (
                    <tr>
                      <td colSpan='6' align='center'>
                        {getListProdukError}
                      </td>
                    </tr>
                  ) : (
                    <tr>
                      <td colSpan='6' align='center'>
                        Data Kosong
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
}
